import { createBrowserHistory } from "history";
import { useRef, useState, useLayoutEffect } from "react";
import { Router } from "react-router-dom";

export const customHistory = createBrowserHistory();

export function CustomBrowserRouter({ basename, children }:any) { // eslint-disable-line
  const historyRef:any = useRef(); // eslint-disable-line
  if (historyRef.current == null) {
    historyRef.current = customHistory;
  }
  const history = historyRef.current;
  const [state, setState] = useState({
    action: history.action,
    location: history.location
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      basename={basename}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    >
      {children}
    </Router>
  );
}
